import React from 'react';

import { Skeleton } from '@dashboard/components/ui/skeleton';

export const FieldsListSkeleton = ({ rows = 3 }) => (
  <div className="border-t border-gray-200 dark:border-border">
    {Array.from({ length: rows }).map((_, index) => (
      <div
        key={index}
        className="flex h-[57px] items-center gap-3 border-b border-gray-200 dark:border-border px-2"
      >
        <Skeleton className="h-4 w-3" />
        <Skeleton className="h-4 w-4" />
        <Skeleton className="h-4 w-28" />
        <Skeleton className="ml-auto h-4 w-4" />
        <Skeleton className="h-4 w-4" />
      </div>
    ))}
  </div>
);

export const FieldsScreenSkeleton = () => (
  <div className="px-4 pt-3 md:px-6">
    <Skeleton className="h-6 w-36" />
    <Skeleton className="mt-0.5 mb-4 h-5 w-72" />
    <FieldsListSkeleton />
  </div>
);
